import React from 'react';
import PropTypes from 'prop-types';

import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import HourglassBottomTwoToneIcon from '@mui/icons-material/HourglassBottomTwoTone';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import BeenhereOutlinedIcon from '@mui/icons-material/BeenhereOutlined';
import VpnLockOutlinedIcon from '@mui/icons-material/VpnLockOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import FingerprintOutlinedIcon from '@mui/icons-material/FingerprintOutlined';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import PhishingIcon from '@mui/icons-material/Phishing';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import HealingIcon from '@mui/icons-material/Healing';
import SecurityIcon from '@mui/icons-material/Security';
import LockClockIcon from '@mui/icons-material/LockClock';

const ICON_MAP = {
  1: <WarningAmberOutlinedIcon className="kpiIcon" />,
  2: <BeenhereOutlinedIcon className="kpiIcon" />,
  3: <HealingIcon className="kpiIcon" />,
  4: <SecurityIcon className="kpiIcon" />,
  5: <SearchOffOutlinedIcon className="kpiIcon" />,
  6: <HourglassBottomTwoToneIcon className="kpiIcon" />,
  7: <VpnLockOutlinedIcon className="kpiIcon" />,
  8: <LockOpenOutlinedIcon className="kpiIcon" />,
  9: <LockClockIcon className="kpiIcon" />,
  10: <CloudDoneOutlinedIcon className="kpiIcon" />,
  11: <DevicesOtherIcon className="kpiIcon" />,
  12: <ExitToAppIcon className="kpiIcon" />,
  13: <AdminPanelSettingsOutlinedIcon className="kpiIcon" />,
  14: <FingerprintOutlinedIcon className="kpiIcon" />,
  15: <SchoolOutlinedIcon className="kpiIcon" />,
  16: <PhishingIcon className="kpiIcon" />,
};
function KpiIcon({ kpiId }) {
  return ICON_MAP[kpiId] || null;
}

KpiIcon.propTypes = {
  kpiId: PropTypes.number.isRequired,
};

export default KpiIcon;
